import React from 'react';
import {useRef} from 'react';
import Drpzone from '../../components/Dropzone/Dropzone.jsx';
import people from './../../assets/people.png';
import './header.css';
import emailjs from '@emailjs/browser';


 const Header = () => {
  const form =useRef()
  
const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_p6hjafb', 'template_kb1di69', form.current, '7k_s6BcQDssC3JMDF')
    .then((result) => {
        console.log(result.text);
    }, (error) => {
        console.log(error.text);
    });
    e.target.reset()
};

  return (
    <div className="container_header gradient__bg">
    <div className='Horizon__header ' id='home'>
      <div className='Horizon__header-content'>
        <h1 className='gradient__text'>Security first </h1>
          <p>Be a part of the family today!!</p>
        
        <form
        ref={form} onSubmit={sendEmail}
         className='Horizon__header-content_input --form-control--card'>
          <input name='user_email' type="user_email" placeholder="Your Email Address" required/>
          <button type="submit">Join Us</button>
        </form>

        <div className='Horizon__header-content_people'>
          <img src={people} alt="ppl"/>
          <p>1,600 people requested access a visit in last 2 weeks</p>
          </div>
         </div>  
         
         
          <div className='Horizon__header-image' style={{ backgroundColor:'#040c18',
  borderRadius: '15px' ,borderRadius: '1',borderStyle: 'dashed', alignItems:'center'}}>
            {/* <img src={controller} alt='controller'/> */}
            
              <Drpzone style={{ width: '100%', height: '100%', }} />
          
          </div>
        </div>
        </div>
  )
};
export default Header;